import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import { ComponentLoader } from '../../global/ComponentLoader/ComponentLoader';

import styles from './PdpSharedTradePointsEarnedMessage.scss';

const importFunc = async () => {
    const mod = await import(
        /* webpackChunkName: "PointsEarnedMessageChunk" */
        'dibs-trade-rewards-progress/exports/PointsEarnedMessage'
    );
    return mod.default;
};

function Placholder() {
    return <div className={styles.placeholder} />;
}

export function PdpSharedTradePointsEarnedMessageComponent(props) {
    const { item, priceInfoDisplay, quantitySelected } = props;

    return (
        <div className={styles.container}>
            <ComponentLoader
                importFunc={importFunc}
                load
                LoadingComponent={Placholder}
                useLoadingComponent={false}
                item={item}
                priceInfoDisplay={priceInfoDisplay}
                quantitySelected={quantitySelected}
            />
        </div>
    );
}

PdpSharedTradePointsEarnedMessageComponent.propTypes = {
    item: PropTypes.object,
    priceInfoDisplay: PropTypes.object,
    quantitySelected: PropTypes.number,
    viewer: PropTypes.object,
};

export const PdpSharedTradePointsEarnedMessage = createFragmentContainer(
    PdpSharedTradePointsEarnedMessageComponent,
    {
        priceInfoDisplay: graphql`
            fragment PdpSharedTradePointsEarnedMessage_priceInfoDisplay on PriceInfoDisplay {
                ...PointsEarnedMessage_priceInfoDisplay @include(if: $isTrade)
            }
        `,
        item: graphql`
            fragment PdpSharedTradePointsEarnedMessage_item on Item {
                ...PointsEarnedMessage_item @include(if: $isTrade)
            }
        `,
    }
);
